import React from 'react'
import { Button, Container, Responsive, Grid } from 'semantic-ui-react'
import HeaderComponent from '../components/HeaderComponent'
import ManutencaoComponent from '../components/ManutencaoComponent'
import InstalacaoComponent from '../components/InstalacaoComponent'
import VendaComponent from '../components/VendaComponent'
import ProjetoComponent from '../components/ProjetoComponent'
import { navigateToSection } from './../js'
import SoliciteOrcamentoComponent from '../components/SoliciteOrcamentoComponent'
import colors from '../js/colors'

/* eslint-disable react/no-multi-comp */
/* Heads up! HomepageHeading uses inline styling, however it's not the best practice. Use CSS or styled components for
 * such things.
 */

const ContentContainer = ({ mobile }) => (
  <Container fluid style={{ backgroundColor: colors.dark }}>
    <HeaderComponent type={mobile} />
    <Responsive minWidth={Responsive.onlyTablet.minWidth}>
      <Container style={{ paddingTop: '50px', marginBottom: '50px' }}>
        <Grid divided="vertically">
          <Grid.Row columns={4}>
            <Grid.Column textAlign="left">
              <ManutencaoComponent />
            </Grid.Column>
            <Grid.Column>
              <InstalacaoComponent />
            </Grid.Column>
            <Grid.Column>
              <VendaComponent />
            </Grid.Column>
            <Grid.Column>
              <ProjetoComponent />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row columns="equal" textAlign="center" verticalAlign="top">
            <Grid.Column>
              <Button primary size="large" onClick={() => navigateToSection('section-produtos')} className="button-custom">
                Conheça nossos Produtos!
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>

      <Container fluid style={{ backgroundColor: colors.dark, marginTop: '50px !important' }}>
        <Container style={{ paddingTop: '50px', marginBottom: '50px' }}>
          <Grid verticalAlign="middle" style={{ maxWidth: 500, margin: 'auto' }}>
            <Grid.Row columns="equal">
              <Grid.Column>
                <SoliciteOrcamentoComponent buttonType={false} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </Container>
    </Responsive>

    <Responsive maxWidth={Responsive.onlyMobile.maxWidth}>
      <Container style={{ paddingTop: '50px', paddingBottom: '50px' }}>
        <Grid stackable>
          <Grid.Row columns={4}>
            <Grid.Column textAlign="left">
              <ManutencaoComponent type={mobile} />
            </Grid.Column>
            <Grid.Column>
              <InstalacaoComponent type={mobile} />
            </Grid.Column>
            <Grid.Column>
              <VendaComponent type={mobile} />
            </Grid.Column>
            <Grid.Column>
              <ProjetoComponent type={mobile} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Responsive>
  </Container>
)

export default ContentContainer
